import { useState } from "react";
import { Stack } from "@mui/material";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import IncidentCard from "../../components/enterprise/IncidentCard";
import IncidentDetailDrawer from "../../components/enterprise/IncidentDetailDrawer";
import { incidentTabs } from "../navigation";
import { platformMockService } from "../../services/mock/platformMockService";
import { useTranslation } from "react-i18next";
import { usePlatform } from "../../context/PlatformContext";
import IncidentCenter from './IncidentCenter';

const CasesPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  const [selected, setSelected] = useState(null);
  const incidents = showMockData ? platformMockService.getIncidents() : [];
  return (
    <ModuleLayout title={t("platform.pages.cases.title")} subtitle={t("platform.pages.cases.subtitle")} breadcrumbs={[t("platform.nav.incidents"), t("platform.tabs.cases")]} tabs={incidentTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <>
          <Stack spacing={1.5}>
            {incidents.map((incident) => <IncidentCard key={incident.id} incident={incident} onOpen={setSelected} />)}
          </Stack>
          <IncidentDetailDrawer open={Boolean(selected)} incident={selected} timeline={platformMockService.getIncidentTimeline()} onClose={() => setSelected(null)} />
        </>
      ) : (
        <IncidentCenter />
      )}
    </ModuleLayout>
  );
};

export default CasesPage;
